import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { env } from '@/app/env';
import type { Database } from './database.types';

/**
 * Cliente Supabase único para toda la app.
 * NO crear nuevos SupabaseClient en otros archivos.
 *
 * Tipado con el esquema generado (`database.types.ts`): sin ese parámetro,
 * `from(...)` y `rpc(...)` devuelven `any` y el tipado se pierde en cuanto los
 * datos entran en la app. Regenerar los tipos tras cada migración.
 */
export const supabase: SupabaseClient<Database> = createClient<Database>(
  env.VITE_SUPABASE_URL,
  env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
    },
    realtime: {
      params: {
        eventsPerSecond: 5,
      },
    },
  }
);
